<div class="search-option">
  <mat-icon svgIcon="twc:shipment" class="entity-icon"></mat-icon>

  <div class="details">
    <div class="title-row">
      <span class="twc-typography-body-1 twc-color-primary-typeface"
        >#{{ option().id }}</span
      >
      @if (option().status; as status) {
        <nx-shipment-status [status]="status" class="ml-8"></nx-shipment-status>
      }
    </div>

    <div
      class="subline auto-ellipsis twc-typography-body-2 twc-color-secondary-typeface"
    >
      {{ option().originPlace || '—' }} → {{ option().destinationPlace || '—' }}
    </div>
  </div>
</div>
